<template>
  <section class="is-hidden-tablet">

    <!-- action wrap -->
    <div  :class="(filterScreen == 1 ? 'active' : '') + ' mobile-filter-actions-wrap default-mobile-actions'">
     <div class="mobile-filter-actions-manage">
       <div class="open-filter-modal-wrap">
         <a href="#" @click.prevent="changeScreen(2)" class="open-filter-modal"><i class="fas fa-angle-up"></i></a> 
       </div>
        <a class="button is-primary" @click.prevent="historyBack()">BACK</a>
        <a class="button is-primary" v-if="vg_cartItems.length > 0" @click.prevent="moveToCheckout()">CHECKOUT</a>
     </div>
    </div>
    <!-- action wrap ends -->

    <!-- action with menu wrap -->
    <div :class="(filterScreen == 2 ? 'active' : '') + ' mobile-action-withmenu-options-wrap'">
      <div class="mobile-action-menus">
        <router-link class="button is-fullwidth mb-3" :to="{ name: 'StoreProfile', params: { business_slug: $route.params.business_slug, store_slug:$route.params.store_slug }, query: $route.query}">PRODUCTS</router-link>
        <a class="button is-fullwidth mb-3" @click.prevent="moveToUserFavorites()">FAVORITES</a>
      </div>
      <div class="mobile-filter-actions-wrap">
        <div class="mobile-filter-actions-manage">
          <div class="open-filter-modal-wrap">
            <a href="#" @click.prevent="changeScreen(1)" class="open-filter-modal"><i class="fas fa-angle-down"></i></a> 
          </div>
          <router-link class="button is-primary" :to="{ name: 'HomePage', params: { business_slug: $route.params.business_slug }, query: $route.query}">BACK</router-link>
          <router-link class="button is-primary" :to="{ name: 'Cart', params: { business_slug: $route.params.business_slug, store_slug: $route.params.store_slug }, query: $route.query}">CART</router-link>
        </div>
      </div>
    </div>
    <!-- action with menu wrap ends -->
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      filterScreen: 1,
    }
  },
  computed: {
    ...mapGetters({
      vg_cartItems: "cart/cartItems",
    }),
  },
  mounted() {
 
  },
  methods: {
    changeScreen(val) {
      this.filterScreen = val;
    },
    /**
     * History back
     */
    historyBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'HomePage', query: this.$route.query });
    },

    /**
     * Send an emit to cart page for checkout
     */
    moveToCheckout() {
      bus.$emit('listen-mobile-moveto-checkout', true)
    },

    /**
     * Move to favorite page with checking
     */
    moveToUserFavorites() {
      if(this.$store.getters.getLoggedInUserToken){
        this.$router.push({
          name: 'UserFavouriteProducts',
          params: { 
            business_slug: this.$route.params.business_slug, 
            store_slug: this.$route.params.store_slug }
        })
      } else {
        this.va_snackbar({
          message:  'Please login to proceed.',
          type: 'error',
        });
      }
    },

    ...mapActions({
      va_snackbar: "snackbar/setSnackbar",
    })
  
  },
}
</script>
